import { api } from './api';

export const routinesApi = {
  cycles: () => api.get('/routines'),
  anchors: (cycle) => api.get(`/routines/${cycle}/anchors`),
  progress: (cycle, anchorId) => api.get(`/routines/${cycle}/progress/${encodeURIComponent(anchorId)}`),
  notifications: (limit = 25) => api.get(`/routines/notifications?limit=${limit}`),
  notificationsCount: () => api.get('/routines/notifications-count'),
  stageThresholds: () => api.get('/routines/stage-thresholds'),
  setStageThresholds: (body) => api.put('/routines/stage-thresholds', body),
};

export const analyticsApi = {
  overview: (period = 'all') => api.get(`/analytics/overview?period=${period}`),
  p2p: (period = 'all') => api.get(`/analytics/p2p?period=${period}`),
  otc: (period = 'all') => api.get(`/analytics/otc?period=${period}`),
};

export const approvalsApi = {
  inbox: (scope, module = 'all', sort = 'waiting_desc') =>
    api.get(`/approvals/inbox?scope=${scope}&module=${encodeURIComponent(module)}&sort=${sort}`),
  count: () => api.get('/approvals/count'),
  act: (body) => api.post('/approvals/act', body),
  assign: (body) => api.post('/approvals/assign', body),
  unassign: (id) => api.delete(`/approvals/assign/${id}`),
  listComments: (doctype, recordId) =>
    api.get(`/approvals/comments?doctype=${encodeURIComponent(doctype)}&record_id=${encodeURIComponent(recordId)}`),
  addComment: (body) => api.post('/approvals/comments', body),
};
